export default {
  '短信设置': '短信設置',
  '返回': '返回',
  '短信模版': '短信模版',
  '查看流水': '查看流水',
  '短信供应商平台': '短信供應商平臺',
  '供应商': '供應商',
  '账号': '賬號',
  '密码': '密碼',
  '取消': '取消',
  '确定': '確定',
  '编辑模板': '編輯模板',
  '保存': '保存',
  '短信模板预览': '短信模板預覽',
  '短信模板编辑区': '短信模板編輯區',
  '不同短信供应商对短信字数限制不一，可能存在字数溢出的情况，请酌情规划模板字数': '不同短信供應商對短信字數限制不壹，可能存在字數溢出的情況，請酌情規劃模板字數',
  '基本信息取值区': '基本信息取值區',
  '点击将标签插入模板，短信会根据标签写入实际数值': '點擊將標簽插入模板，短信會根據標簽寫入實際數值',
  '验证码': '驗證碼',
  '提示': '提示',
  '若模板没有保存，直接返回会丢失已修改的模板哦。确定吗？': '若模板沒有保存，直接返回會丟失已修改的模板哦。確定嗎？',
  '功能类型': '功能類型',
  '短信类型': '短信類型',
  '短信属性': '短信屬性',
  '操作': '操作',
  '全局': '全局',
  '渠道': '渠道',
  '开卡': '開卡',
  '储值卡': '儲值卡',
  '消费': '消費',
  '其他': '其他',
  '开卡手机验证码': '開卡手機驗證碼',
  '开卡成功提醒': '開卡成功提醒',
  '会员储值卡使用验证码': '會員儲值卡使用驗證碼',
  '会员储值卡充值成功提醒': '會員儲值卡充值成功提醒',
  '会员储值卡消费成功提醒': '會員儲值卡消費成功提醒',
  '会员积分使用验证码': '會員積分使用驗證碼',
  '会员积分充值成功提醒': '會員積分充值成功提醒',
  '会员积分消费成功提醒': '會員積分消費成功提醒',
  '特殊会员VIP折扣使用': '特殊會員VIP折扣使用',
  '高级折扣权限短信验证码': '高級折扣權限短信驗證碼',
  '消费成功提醒': '消費成功提醒',
  '定金单下单成功提醒': '定金單下單成功提醒',
  '修改会员手机号成功提醒': '修改會員手機號成功提醒',
  '会员等级变动提醒': '會員等級變動提醒',
  '停用': '停用',
  '启用': '啟用',
  '未开通短信服务': '未開通短信服務',
  '配置': '配置',
  '请联系信息部门': '請聯系信息部門',
  '店铺': '店鋪',
  '序': '序',
  '搜索': '搜索',
  '店铺编号': '店鋪編號',
  '店铺名称': '店鋪名稱',
  '知道了': '知道了',
  '快捷设置': '快捷設置',
  '刷新促销': '刷新促銷',
  'Web端使用ERP物流模块': 'Web端使用ERP物流模塊',
  '模板内容': '模板內容',
  '模板方案': '模板方案',
  '同步ERP渠道资料': '同步ERP渠道資料',
  '未审核': '未審核',
  '审核中': '審核中',
  '审核通过': '審核通過',
  '审核失败': '審核失敗',
  '添加账号': '添加賬號',
  '确认删除该短信模板吗？': '確認刪除該短信模板嗎？',
  '删除': '刪除',
  '重命名': '重命名',
  '默认': '默認',
  '国际': '國際',
  '中文': '中文',
  '未配置模板的渠道将按默认模板发送短信': '未配置模板的渠道將按默認模板發送短信',
  '确认切换默认模板吗？': '確認切換默認模板嗎？',
  '添加模板': '添加模板',
  '审核状态': '審核狀態',
  '添加中文模板': '添加中文模板',
  '添加国际模板': '添加國際模板',
  '申请说明': '申請說明',
  '确认删除该短信签名吗？': '確認刪除該短信簽名嗎？',
  '默认签名': '默認簽名',
  '审核备注': '審核備註',
  '签名来源': '簽名來源',
  '签名名称': '簽名名稱',
  '添加短信签名': '添加短信簽名',
  '短信签名': '短信簽名',
  '请在申请说明中 详细描述您的业务使⽤场景，申请⼯信部备案⽹站的全称或简称请在此处填写域名，长度不超过200个字符': '請在申請說明中 詳細描述您的業務使⽤場景，申請⼯信部備案⽹站的全稱或簡稱請在此處填寫域名，長度不超過200個字符',
  '请输入签名名称': '請輸入簽名名稱',
  '当前⽀持jpg、png、gif或 jpeg格式的图⽚。': '當前⽀持jpg、png、gif或 jpeg格式的圖⽚。',
  '签名的证明⽂件格式，⽀持上传多张图⽚。': '簽名的證明⽂件格式，⽀持上傳多張圖⽚。',
  '图片不超过2M': '圖片不超過2M',
  '提交审核': '提交審核',
  '证明文件': '證明文件',
  '短信供应商设置': '短信供應商設置',
  '短信签名未设置': '短信簽名未設置',
  '短信将无法发送': '短信將無法發送',
  '同步阿里云短信签名': '同步阿裏雲短信簽名',
  '渠道(批量)选择': '渠道(批量)選擇',
  '查询': '查詢',
  '渠道编号': '渠道編號',
  '请输入渠道编号': '請輸入渠道編號',
  '渠道简称': '渠道簡稱',
  '请输入渠道简称': '請輸入渠道簡稱',
  '经营模式': '經營模式',
  '经营方式': '經營方式',
  '输入或选择': '輸入或選擇',
  '公司': '公司',
  '组': '組',
  '国家': '國家',
  '销售类别': '銷售類別',
  '渠道配置（已选择': '渠道配置（已選擇',
  '复制渠道配置（已选择': '復製渠道配置（已選擇',
  '个渠道': '個渠道',
  '单据打印样式': '單據打印樣式',
  '单据': '單據',
  '销售单': '銷售單',
  '定金单': '定金單',
  '会员充值单': '會員充值單',
  '日结': '日結',
  '交接班': '交接班',
  '本机日收银': '本機日收銀',
  '发货单': '發貨單',
  '单据打印张数': '單據打印張數',
  '短信模板': '短信模板',
  '会员等级变动升级提醒': '會員等級變動升級提醒',
  '选择短信模板': '選擇短信模板',
  '模版方案': '模版方案',
  '模版内容': '模版內容',
  '阿里云短信签名': '阿裏雲短信簽名',
  '选择短信签名': '選擇短信簽名',
  '保存成功': '保存成功',
  '打印张数': '打印張數',
  '输入张数': '輸入張數',
  '做单打印': '做單打印',
  '店铺联': '店鋪聯',
  '客户联': '客戶聯',
  '张数': '張數',
  '不能全部为零': '不能全部為零',
  '请填写完整的张数': '請填寫完整的張數',
  '选择样式': '選擇樣式',
  '简易版': '簡易版',
  '简易版支持全部终端': '簡易版支持全部終端',
  '类型': '類型',
  '自定义版': '自定義版',
  '样式名称': '樣式名稱',
  '预览': '預覽',
  '自定义版仅支持Webpos优先使用': '自定義版僅支持Webpos優先使用',
  '变更记录': '變更記錄',
  '销售单小票': '銷售單小票',
  '定金单小票': '定金單小票',
  '充值单': '充值單',
  '请先选择模版': '請先選擇模版',
  '再保存': '再保存',
  '充值单据': '充值單據',
  '500条/页': '500條/頁',
  '第': '第',
  '页': '頁',
  '共': '共',
  '没有可选的数据': '沒有可選的數據',
  '渠道配置中心': '渠道配置中心',
  '支持配置小票样式&打印张数、短信模板': '支持配置小票樣式&打印張數、短信模板',
  '配置说明': '配置說明',
  '配置后，POS需重新登录后生效': '配置後，POS需重新登錄後生效',
  '渠道(批量)': '渠道(批量)',
  '请输入内容': '請輸入內容',
  '选项': '選項',
  '清空': '清空',
  '已选择': '已选择',
  '状态': '状态',
  '列表': '列表',
  '编辑': '編輯',
  '户口': '戶口',
  '批量配置单据打印样式': '批量配置單據打印樣式',
  '批量配置单据打印张数': '批量配置單據打印張數',
  '批量配置短信模板': '批量配置短信模板',
  '复制其他渠道模板': '復製其他渠道模板',
  '会员充值小票': '會員充值小票',
  '日结小票': '日結小票',
  '交接班小票': '交接班小票',
  '本机日收银小票': '本機日收銀小票',
  '发货单小票': '發貨單小票',
  '做单打印张数 店铺联/客户联': '做單打印張數 店鋪聯/客戶聯',
  '重打印张数 店铺联/客户联': '重打印張數 店鋪聯/客戶聯',
  '未选择业务属性': '未選擇業務屬性',
  '请选择渠道': '請選擇渠道',
  '同步ERP渠道资料成功！': '同步ERP渠道資料成功！',
  '系统默认模版': '系統默認模版',
  '做单': '做單',
  '企事业单位的全称或简称': '企事業單位的全稱或簡稱',
  '工信部备案网站的全称或简称': '工信部備案網站的全稱或簡稱',
  'APP应用的全称或简称': 'APP應用的全稱或簡稱',
  '公众号或小程序的全称或简称': '公眾號或小程序的全稱或簡稱',
  '电商平台店铺名的全称或简称': '電商平臺店鋪名的全稱或簡稱',
  '商标名的全称或简称': '商標名的全稱或簡稱',
  '请输入签名来源': '請輸入簽名來源',
  '请输入签名说明': '請輸入簽名說明',
  '重新上传成功': '重新上傳成功',
  '重新上传': '重新上傳',
  '添加成功': '添加成功',
  '上传图片不能大于2M': '上傳圖片不能大於2M',
  '短信模板数量不能超过10个': '短信模板數量不能超過10個',
  '请输入名称': '請輸入名稱',
  '保存后': '保存後',
  '模版将提交审核，': '模版將提交審核，',
  '审核通过前短信模版无法使用，确认吗？': '審核通過前短信模版無法使用，確認嗎？',
  '已经存在该字段，不可重复添加': '已經存在該字段，不可重復添加',
  '请选择要编辑的模版': '請選擇要編輯的模版',
  '保存置灰且点击提示“审核中”“审核通过”模板不可修改': '保存置灰且點擊提示“審核中”“審核通過”模板不可修改',
  '删除成功': '刪除成功',
  '超过最大字数': '超過最大字數',
  '模版中含有非法取值字段，请先删除再保存': '模版中含有非法取值字段，請先刪除再保存',
  '短信模板不能为空！': '短信模板不能為空！',
  '短信模板缺少验证码！': '短信模板缺少驗證碼！',
  '短信模板保存成功': '短信模板保存成功',
  '重命名成功': '重命名成功',
  '同步阿里云签名': '同步阿裏雲簽名',
  '输入在阿里云后台注册的签名名称，同步至企业管理后台': '輸入在阿裏雲後臺註冊的簽名名稱，同步至企業管理後臺',
  '签名名称不能为空': '簽名名稱不能為空',
  '同步签名成功': '同步簽名成功',
  '更新默认签名成功': '更新默認簽名成功',
  '删除签名成功': '刪除簽名成功',
  '请勿轻易切换供应商，审核状态将会被重置！': '請勿輕易切換供應商，審核狀態將會被重置！',
  '区域': '區域',
  '省份': '省份',
  '渠道性质': '渠道性質',
  '店铺联/顾客联打印张数不能全部为0': '店鋪聯/顧客聯打印張數不能全部為0',
  '销售退款（储值积分返还）提醒': '銷售退款（儲值積分返還）提醒',
  '渠道调出': '渠道調出',
  '渠道退货': '渠道退貨',
  '采购退货': '采購退貨',
  '退货通知': '退貨通知',
  '线上订单发货': '線上訂單發貨',
  '渠道调入': '渠道調入',
  '渠道收货': '渠道收貨',
  '退货': '退貨',
  '积分': '積分',
  '紧急发货': '緊急發貨',
  '发货': '發貨',
  '配单': '配單',
  '验货': '驗貨',
  '全部': '全部',
  '配置教学': '配置教學',
  '已配置短信渠道': '已配置短信渠道',
  '已开启ERP权限': '已開啟ERP權限',
  '未开启ERP权限': '未開啟ERP權限',
  '配置了该短信模板且已开通ERP权限的渠道，可正常使用短信功能': '配置了該短信模板且已開通ERP權限的渠道，可正常使用短信功能',
  '配置了该模板但未开通ERP权限的渠道,请前往ERP渠道资料开通权限': '配置了該模板但未開通ERP權限的渠道,請前往ERP渠道資料開通權限',
  '短信配置主要为以下流程': '短信配置主要為以下流程',
  '设置好短信签名，提交供应商审核（部分供应商无需配置签名）': '設置好短信簽名，提交供應商審核（部分供應商無需配置簽名）',
  '点击短信类型右侧的编辑模板，保存后提交供应商审核': '點擊短信類型右側的編輯模板，保存後提交供應商審核',
  '到': '到',
  '开通渠道': '开通渠道',
  '重打印': '重打印',
  '是否保存模板？': '是否保存模板？',
  '给不同渠道配置对应模板': '給不同渠道配置對應模板',
  '请先选择模版再保存': '请先选择模版再保存',
  '前往ERP渠道资料，开启所有渠道的短信发送权限': '前往ERP渠道資料，開啟所有渠道的短信發送權限',
  '全部数据导入成功': '全部數據導入成功',
  '零售方式': '零售方式',
  '积分清零提醒': '積分清零提醒',
  '生日代用券': '生日代用券',
  '短信签名一般为品牌名称，顾客短信可见，必填': '短信簽名壹般為品牌名稱，顧客短信可見，必填',
  '请填写短信签名': '請填寫短信簽名',
  '若清空供应商，可能会丢失原有短信供应商的模板审核状态，请谨慎操作': '若清空供應商，可能會丟失原有短信供應商的模板審核狀態，請謹慎操作。',
  '查询结果': '查詢結果',
  '搜索渠道': '搜索渠道',
  '重置': '重置',
  '条': '條',
  '100条/页': '100/行',
  '200条/页': '200/行',
  '300条/页': '300/行',
  '400条/页': '400/行',
  '请输入账号': '請輸入賬號',
  '输入账号': '輸入賬號',
  '请输入密码': '請輸入密碼',
  '输入密码': '輸入密碼',
  '同步ERP收银员': '同步ERP收銀員',
  '账号不能为空': '賬號不能為空',
  '使用教程': '使用教程',
  '不记名储值卡余额变动提醒': '不記名儲值卡余額變動提醒',
  '不记名储值卡开卡成功提醒': '不記名儲值卡開卡提醒',
  '不记名卡使用验证': '不记名卡使用验证',
  '打印单据张数': '打印單據張數',
  '打印快递单张数': '打印快遞單張數',
  '打印单据': '打印单据',
  '打印快递单': '打印快递单',
  '更新版本': '更新版本',
  '更新版本成功': '更新版本成功',
  '大版本号': '大版本號',
  '忘记密码发送随机密码提醒': '忘記密碼發送隨機密碼提醒',
  '修改密码成功提醒': '修改密碼成功提醒',
  'VIP积分兑换货品短信验证': 'VIP積分兌換貨品簡訊驗證'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-hant/note.js